<template>
  <Schedule
    v-if="due"
    position="left"
    widthClass="dwp-w-56"
    :open.sync="open.schedule"
    v-model="due"
    @change="$emit('schedule', $event)"
  >
    <div data-cy="task-due-date" :class="timeClass">{{ humanDate }}</div>
  </Schedule>
</template>

<script>
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import isToday from "dayjs/plugin/isToday";
import isTomorrow from "dayjs/plugin/isTomorrow";
import isYesterday from "dayjs/plugin/isYesterday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import Schedule from "@/components/shared/Schedule.vue";

dayjs.extend(isToday);
dayjs.extend(isTomorrow);
dayjs.extend(isYesterday);
dayjs.extend(relativeTime);
dayjs.extend(weekOfYear);

export default {
  props: {
    due: String | Date,
  },

  components: {
    Schedule,
  },

  data() {
    return {
      open: {
        schedule: false,
      },
      timeClass: "dwp-text-gray-600",
    };
  },

  computed: {
    humanDate() {
      let date = this?.due;
      if (typeof this.due.toDate == "function") {
        date = this?.due?.toDate();
      }

      if (!date) {
        return;
      }

      if (dayjs(date).isYesterday()) {
        this.timeClass = "dwp-text-red-500";
        return "Yesterday";
      }

      if (dayjs(date).isToday()) {
        this.timeClass = "dwp-text-green-500";
        return "Today";
      }

      if (dayjs(date).isTomorrow()) {
        this.timeClass = "dwp-text-orange-500";
        return "Tomorrow";
      }

      let thisWeek = dayjs().week();
      let dueWeek = dayjs(date).week();

      if (thisWeek == dueWeek && !dayjs(date).isBefore(dayjs())) {
        this.timeClass = "dwp-text-primary";
        return "This " + dayjs(date).format("dddd");
      }

      if (thisWeek + 1 == dueWeek) {
        this.timeClass = "dwp-text-indigo-500";
        return "Next " + dayjs(date).format("dddd");
      }

      if (dayjs(date).isBefore(dayjs())) {
        this.timeClass = "dwp-text-red-500";
      } else {
        this.timeClass = "dwp-text-gray-600";
      }

      return dayjs(date).fromNow();
    },
  },
};
</script>